import styled from 'styled-components'

import mediaQueries from 'components/media-queries'

export const InfoTextList = styled.ul`
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.grayScorpion};
  font-size: 16px;
  list-style: none;
  padding-left: 10px;
  ${mediaQueries.mobile`
     font-size: 14px;
  `};
`

export const InfoTextListItem = styled.li`
  &::before {
    content: '\\2022';
    color: ${({ theme }) => theme.colors.blue};
    font-size: 25px;
    font-weight: bold;
    display: inline-block;
    width: 20px;
    list-style-position: inside;
    align-content: center;
  }
`
